<template>
    <div class="disLike-chart">
        <div class="overview-title">
            <span class="overview-title-text">{{ dislikeReason }}</span>
        </div>
        <ECharts class="v-echarts" :options="options" autoresize />
    </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
    components: {
        ECharts
    },
    props: ["data"],
    data() {
        return {
            options: {}
        }
    },
    computed: {
        dislikeHistogram() {
            return this.getStorePorp("dislikeHistogram");
        },
        dislikeReason() {
            return this.$t("zhiji.likedisplay.dislikeReason"); 
        },
        dislikeOne() {
            return this.$t("zhiji.likedisplay.evaluateDissatisfactionNum"); 
        },
        dislikeTwo() {
            return this.$t("zhiji.likedisplay.evaluateIrrelevant"); 
        },
        dislikeThree() {
            return this.$t("zhiji.likedisplay.evaluateUnresolved"); 
        },
        dislikeOther() {
            return this.$t("zhiji.likedisplay.evaluateCustomized"); 
        },
    },
    watch: {
        dislikeHistogram(data) {
            this.options = this.getOptions(data);
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.likeDisplaySatis[propName];
        },
        getOptions(data) {
            return {
                color: ["#D9E4EF", "#3FBDFF", "#FF886E", "#FDDB50"],
                legend: {
                    data: [
                        {
                            name: this.dislikeOne, // 满意率
                            icon: "circle"
                        },
                        {
                            name: this.dislikeTwo, // 有效满意率
                            icon: "circle"
                        },
                        {
                            name: this.dislikeThree, // 参评率
                            icon: "circle"
                        },
                        {
                            name: this.dislikeOther, // 参评率
                            icon: "circle"
                        },
                    ],
                    left: 0,
                    itemGap: 20
                },
                tooltip: {
                    trigger: "axis",
                    textStyle: {
                        align: "left"
                    }
                },
                grid: {
                    left: "40",
                    right: "60",
                    bottom: "20",
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: "category",
                    axisLine: {
                        lineStyle: {
                            color: "#B2BBDF"
                        }
                    },
                    axisLabel: {
                        color: "#41475e",
                        padding: [8, 0, 0, 0]
                    },
                    data: data.xAxisData
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        show: false,
                        symbol: "none"
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#ECF1F7"
                        }
                    },
                },
                series: this.getSeries(data)
            };
        },
        getSeries(datas) {
            const lines = [
                {
                    name: this.dislikeOne,
                    color: "#D9E4EF",
                    id: "dislikeOne",
                },
                {
                    name: this.dislikeTwo,
                    color: "#3FBDFF",
                    id: "dislikeTwo"
                },
                {
                    name: this.dislikeThree,
                    color: "#FF886E",
                    id: "dislikeThree"
                },
                {
                    name: this.dislikeOther,
                    color: "#FDDB50",
                    id: "dislikeOther"
                }
            ];

            return lines.map(function(line) {
                return {
                    name: line.name,
                    type: "bar",
                    smooth: true,
                    stack: "Ad",
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                color: line.color
                            }
                        }
                    },
                    data: datas && datas[line.id] ? datas[line.id] : []
                };
            });
        }
    }
}
</script>

<style lang="less" scoped>
.disLike-chart {
    box-sizing: border-box;
    padding: 16px 24px 6px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d8e4f0;
    margin-top: 16px;

    .overview-title {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #d8e4f0;
        margin-bottom: 10px;
    
        .overview-title-text {
            font-size: 14px;
            font-weight: bold;
            color: #41475e;
        }
    }
}
</style>